import { makeBiggerHoleFiles, makeCvObj, svgAndPngToCvImages, svgToFile } from './priviate/core.js';
import { each, flatMap, go, map, tap, sel } from 'fxjs/es';
import { BpOptionKeyRingConstantS } from '../../../../../BpOption/KeyRing/S/Constant/module/BpOptionKeyRingConstantS.js';
import { makeDefaultCvImageAttrs } from '../../../../../Maker/F/CvImage/fs.js';
import { UtilObjS } from '../../../../../Util/Object/S/Function/module/UtilObjS.js';

const makeKeyringCvObj = async ({
  svg_el,
  material,
  ratio,
  holed_thumbnail_canvas,
  hook_position_ratio,
  hole_radius_cm,
  angle,
}) => {
  const { canvas, coord } = await svgAndPngToCvImages({
    svg_el,
    design_canvas: holed_thumbnail_canvas,
    hook_position_ratio,
    material,
    ratio,
    hole_radius_cm,
    angle,
  });
  const main_cv_obj = await go(
    canvas,
    (canvas) => {
      return {
        url: canvas.toDataURL(),
        width: canvas.width,
        height: canvas.height,
      };
    },
    (obj) => {
      obj.height_cm = ((obj.height / 300) * 2.54) / ratio;
      obj.width_cm = ((obj.width / 300) * 2.54) / ratio;
      return obj;
    },
    makeDefaultCvImageAttrs,
  );

  const cv_obj = await makeCvObj({
    main_cv_obj,
  });

  cv_obj._data.hole_position = coord;
  return cv_obj;
};

const makeKeyringMaterial = async ({
  svg_el,
  material,
  printable_canvas,
  thumbnail_canvas,
  hook_position_ratio,
  hole_radius_cm,
  angle,
}) => {
  const real_size = {
    width: Math.round((printable_canvas.width / 300) * 2.54 * 10),
    height: Math.round((printable_canvas.height / 300) * 2.54 * 10),
  };
  const { file: printable_png_file } = await makeBiggerHoleFiles(
    printable_canvas,
    hook_position_ratio,
    hole_radius_cm,
  );
  const ratio = (await go(thumbnail_canvas, sel('width'))) / (await go(printable_canvas, sel('width')));

  const { canvas: holed_thumbnail_canvas } = await makeBiggerHoleFiles(
    thumbnail_canvas,
    hook_position_ratio,
    hole_radius_cm,
    ratio,
  );
  const svg_product_materials = [
    {
      printable_file: printable_png_file,
      original_cutting_line_svg_file: await svgToFile(svg_el),
    },
  ];

  const cv_obj = await makeKeyringCvObj({
    svg_el: svg_el.cloneNode(true),
    material,
    ratio,
    holed_thumbnail_canvas,
    hook_position_ratio,
    hole_radius_cm,
    angle,
  });

  cv_obj._data.fitted_size = real_size;
  cv_obj._data.width_cm = real_size.width;
  cv_obj._data.height_cm = real_size.height;
  return {
    svg_product_materials,
    cv_obj,
  };
};

function getMaterial(selected_option_group_bp_ids) {
  if (selected_option_group_bp_ids.includes(BpOptionKeyRingConstantS.KEYRING_MATERIAL_GL_BP_OPTION_ID)) {
    return 'gl';
  } else if (
    selected_option_group_bp_ids.includes(BpOptionKeyRingConstantS.KEYRING_MATERIAL_AU_BP_OPTION_ID)
  ) {
    return 'au';
  } else {
    return '';
  }
}

function setAcrilCvObj({ pf, acril_cv_obj, cid }) {
  pf.designs = go(
    pf.designs,
    map((cv_design) => {
      if (cv_design.cid !== cid) return cv_design;
      return acril_cv_obj.toObject();
    }),
  );
}
function makeKeyringMaterialPrams(result, selected_option_group_bp_ids, hole_radius_cm) {
  return {
    svg_el: result.cutlineSvgEl,
    material: getMaterial(selected_option_group_bp_ids),
    printable_canvas: result.canvas,
    thumbnail_canvas: result.canvas,
    hook_position_ratio: {
      x: result.structurePoint.x / result.canvas.width,
      y: result.structurePoint.y / result.canvas.height,
    },
    hole_radius_cm,
  };
}

function setSizeByHoleAndPxPer1cm({ cv_obj, px_per_1cm, hole_position }) {
  const width = cv_obj._data.image_width_cm * px_per_1cm;
  cv_obj.scaleX = width / cv_obj.width;
  cv_obj.scaleY = cv_obj.scaleX;
  cv_obj.top = hole_position.y - cv_obj._data.hole_position.y * (cv_obj.height * cv_obj.scaleY);
  cv_obj.left = hole_position.x - cv_obj._data.hole_position.x * width;
}

function setLocationAndSize(target_cv_obj, px_per_1cm, { hole_position } = {}) {
  const main_cv_obj_width = target_cv_obj._data.image_width_cm * px_per_1cm;
  target_cv_obj.scaleX = main_cv_obj_width / target_cv_obj.width;
  target_cv_obj.scaleY = target_cv_obj.scaleX;
  const main_cv_obj_height = target_cv_obj.height * target_cv_obj.scaleY;
  target_cv_obj.top = hole_position
    ? hole_position.top - target_cv_obj._data.hole_position.y * main_cv_obj_height
    : 0;
  target_cv_obj.left = hole_position
    ? hole_position.left - target_cv_obj._data.hole_position.x * main_cv_obj_width
    : 0;
}
// bottom_gori._data.hole_position.y * bottom_gori_height

export const nessMakeKeyringMaterial = async ({
  main_result,
  charm_result,
  product_face,
  selected_option_group,
}) => {
  const selected_option_group_bp_ids = selected_option_group?.bp_option_ids;
  if (!selected_option_group_bp_ids?.length)
    throw new Error('selected_option_group.bp_option_ids is required');
  const main_cv_obj_cid = 'c2323';
  const charm_cv_obj_cid = 'c2424';
  const hole_radius_cm = 0.15;
  const { cv_obj: main_acril_cv_obj, svg_product_materials } = await go(
    makeKeyringMaterialPrams(main_result, selected_option_group_bp_ids, hole_radius_cm),
    makeKeyringMaterial,
    tap(({ cv_obj }) => {
      cv_obj.cid = main_cv_obj_cid;
    }),
  );
  const { cv_obj: charm_acril_cv_obj, svg_product_materials: charm_svg_product_materials } = charm_result
    ? await go(
        makeKeyringMaterialPrams(charm_result, selected_option_group_bp_ids, hole_radius_cm),
        (args) => makeKeyringMaterial({ ...args, angle: -25 }),
        tap(({ cv_obj }) => {
          cv_obj.cid = charm_cv_obj_cid;
        }),
      )
    : {};
  const designs = go(
    UtilObjS.deepClone(product_face.designs),
    flatMap((cv_design) => {
      if (cv_design.cid !== main_cv_obj_cid) return [cv_design];
      return [main_acril_cv_obj.toObject(), charm_acril_cv_obj.toObject()];
    }),
  );
  const px_per_1cm = 50;
  const bottom_gori = designs[0];
  const main_hole_position = {
    top: bottom_gori._data.hole_position.y * bottom_gori.height * bottom_gori.scaleY,
    left: bottom_gori._data.hole_position.x * bottom_gori.width * bottom_gori.scaleX,
  };
  const charm_hole_position = {
    top: bottom_gori._data.charm_position.y * bottom_gori.height * bottom_gori.scaleY,
    left: bottom_gori._data.charm_position.x * bottom_gori.width * bottom_gori.scaleX,
  };
  setLocationAndSize(bottom_gori, px_per_1cm);
  /* 고리 0, 0에 세팅 */
  setLocationAndSize(designs[1], px_per_1cm, {
    hole_position: main_hole_position,
  });
  setLocationAndSize(designs[2], px_per_1cm, {
    hole_position: charm_hole_position,
  });
  setLocationAndSize(designs[3], px_per_1cm);
  const scaled_designs = await makeCvDesignsFittedSizeByFabric(designs);
  // const scaled_designs = makeCvDesignsFittedSize(designs);

  return {
    designs: scaled_designs,
    svg_product_materials: svg_product_materials.concat(charm_svg_product_materials),
  };
};

function getGoriPostionY(pf, px_per_1cm, canvas_default_height) {
  const gori_height_cm = pf.designs[0]._data.image_height_cm * pf.designs[0]._data.hole_position.y;
  const gori_height_margin_px =
    pf.designs[0]._data.image_height_cm * (pf.designs[0]._data.height_margin_ratio || 0.1) * px_per_1cm;
  const design_height_cm = pf.designs[1]._data.image_height_cm * (1 - pf.designs[1]._data.hole_position.y);
  const total_height_cm = gori_height_cm + design_height_cm;
  const gori_hole_y_ratio = gori_height_cm / total_height_cm;
  const total_height_px = total_height_cm * px_per_1cm;
  const top = (canvas_default_height - total_height_px) / 2;
  return {
    gori_position_y: Math.round(top + total_height_px * gori_hole_y_ratio - gori_height_margin_px),
    total_height_px,
  };
}

function makePxPer1CmAndGoryY(pf) {
  const canvas_default_height = 860;
  const margin = 30;
  const px_per_1cm = pf.size_faces[0].px_per_1cm;
  const { gori_position_y, total_height_px } = getGoriPostionY(pf, px_per_1cm, canvas_default_height);
  const max_design_size = canvas_default_height - margin * 2;
  if (total_height_px >= max_design_size) {
    const ratio = max_design_size / total_height_px;
    const px_per_1cm = pf.size_faces[0].px_per_1cm * ratio;
    const { gori_position_y } = getGoriPostionY(pf, px_per_1cm, canvas_default_height);
    return {
      px_per_1cm,
      gori_position_y,
    };
  } else {
    return {
      px_per_1cm,
      gori_position_y,
    };
  }
}

async function makeCvDesignsFittedSizeByFabric(designs) {
  const size = 860;
  const margin = 50;
  const max_size = size - margin * 2;
  const f_canvas = new fabric.StaticCanvas(document.createElement('canvas'), {
    width: size,
    height: size,
    enableRetinaScaling: false,
  });
  const cv_objs = await go(
    designs,
    map((cv_obj) => {
      return G.mp.maker.from_cv_attrs_for_maker(cv_obj, 1);
    }),
  );
  const group = new fabric.Group(
    cv_objs,
    // cv_objs.concat([
    //   new fabric.Rect({
    //     ...main_hole_position,
    //     fill: 'red',
    //     width: 2,
    //     height: 2,
    //   }),
    // ]),
  );
  f_canvas.add(group);
  if (group.width > group.height) {
    group.scaleToWidth2(max_size);
    group.left = margin;
    group.top = (size - group.height * group.scaleY) / 2;
  } else {
    group.scaleToHeight2(max_size);
    group.top = margin;
    group.left = (size - group.width * group.scaleX) / 2;
  }
  group._restoreObjectsState();
  return go(
    group._objects,
    map((cv_obj) => cv_obj.toObject()),
  );
}

async function makeCvDesignsFittedSizeByFabric2(designs) {
  const size = 860;
  const f_canvas = new fabric.StaticCanvas(document.createElement('canvas'), {
    width: size,
    height: size,
    enableRetinaScaling: false,
  });
  await go(
    designs,
    map((cv_obj) => {
      return G.mp.maker.from_cv_attrs_for_maker(cv_obj, 1);
    }),
    each((cv_obj) => {
      f_canvas.add(cv_obj);
    }),
  );
}
function makeCvDesignsFittedSize(designs) {
  designs = JSON.parse(JSON.stringify(designs));
  const temp_group = { top: 0, left: 0, width: 0, height: 0 };
  const size = 860;
  const margin = 50;
  const max_size = size - margin * 2;
  go(
    designs,
    each((design) => {
      temp_group.top = Math.min(temp_group.top, design.top);
      temp_group.left = Math.min(temp_group.left, design.left);
      temp_group.width = Math.max(temp_group.width, design.left + design.width * design.scaleX);
      temp_group.height = Math.max(temp_group.height, design.top + design.height * design.scaleY);
    }),
  );
  if (temp_group.width > temp_group.height) {
    temp_group.scale = max_size / temp_group.width;
  } else {
    temp_group.scale = max_size / temp_group.height;
  }
  go(
    designs,
    each((design) => {
      design.scaleX *= temp_group.scale;
      design.scaleY *= temp_group.scale;
      design.top -= temp_group.top;
      design.left -= temp_group.left;
      design.top *= temp_group.scale;
      design.left *= temp_group.scale;
    }),
  );
  if (temp_group.width > temp_group.height) {
    temp_group.left = margin - temp_group.left;
    temp_group.top = (size - temp_group.height * temp_group.scale) / 2 - temp_group.top;
  } else {
    temp_group.top = margin - temp_group.top;
    temp_group.left = (size - temp_group.width * temp_group.scale) / 2 - temp_group.left;
  }
  go(
    designs,
    each((design) => {
      design.top += temp_group.top;
      design.left += temp_group.left;
    }),
  );
  return designs;
}

// G.keyring_setting = {
//   normXY: async ({ url, width, height, x1, y1, x2, y2 }) => {
//     function toFixedNumber(n) {
//       return parseFloat(n.toFixed(4));
//     }
//     const image = await loadImageFromUrl(url);
//     return {
//       src: url,
//       _data: {
//         name: '',
//         cv_type: 'cv_image',
//         name_en: '',
//         name_jp: '',
//         is_embro: false,
//         price: 0,
//         price_jp: 0,
//         price_en: 0,
//         image_url: url,
//         hole_position: {
//           x: toFixedNumber(x1 / image.width),
//           y: toFixedNumber(y1 / image.height),
//         },
//         charm_position: {
//           x: toFixedNumber(x2 / image.width),
//           y: toFixedNumber(y2 / image.height),
//         },
//         image_width_cm: width,
//         original_is_ai: null,
//         image_height_cm: height,
//         is_marpple_image: false,
//         design_collection_type: null,
//       },
//     };
//   },
// };
